<template>
  <div>
    <v-autocomplete
      v-bind="$attrs"
      v-model="selected_client_id"
      :items="clients"
      :item-text="formatClientDisplayName"
      item-value="id"
      label="Cliente"
      :loading="loading_clients"
      :readonly='loading_clients'
      prepend-icon="mdi-star"
      :filter="filterClients"
    >
      <template v-slot:selection="{item}">
        <v-sheet width="100%" class="d-flex flex-column justify-start mt-2">
          <span> {{ formatClientDisplayName(item) }} <span v-if="item.fantasyName">({{ item.fantasyName }})</span> </span>
          <div class="d-flex justify-space-between mt-1 align-center">
            <span class="caption">ID: {{item.id}}</span>
            <span class="caption">Cidade: {{ item.city }} </span>
          </div>
        </v-sheet>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title class="pb-1"> Nome/Rz social: <b> {{ formatClientDisplayName(item) }} </b> </v-list-item-title>
          <v-list-item-subtitle class="mb-1" v-if="item.fantasyName && item.fantasyName != item.name">Nome fantasia: <b> {{item.fantasyName}} </b></v-list-item-subtitle>
          <v-list-item-subtitle class="d-flex justify-space-between">
            <div>ID: <b>{{ item.id }} </b> </div>
            <div>Cidade: <b>{{ item.city }}</b></div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapActions, mapState, mapGetters } from 'vuex'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name: 'SelectOneClient',
  mixins: [clientDisplay],
  inheritAttrs: false,
  props: {
  },
  components: {
  },
  data() {
    return {
      loading_clients: false,
      clients: [],
      selected_client_id: null,
    }
  },
  methods: {
    getData(){
      this.getClients()
    },
    emitClient(){
      this.$emit('changeClient', this.selected_client_id)
    },
    getClients() {
      if (this.activeModalityId){
        this.loading_clients = true
        let filter = {modality_id: this.activeModalityId, short: true}
  
        Api.Client.index(filter).then(r => r.data).then(r => {
          r = r.data? r.data.map(d => d.attributes) : r
          const clients = Array.isArray(r) ? r : []
          this.clients = clients.filter(c => !this.isFinalClient(c))
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.loading_clients = false
        })
      }
    },
    isFinalClient (client) {
      const label = `${client?.name || ''} ${client?.corporateName || ''}`.toLowerCase()
      return label.includes('cliente final')
    },
    filterClients (item, queryText, itemText) {
      const name = item.name ? item.name.toLowerCase() : ''
      const corporate_name = item.corporateName ? item.corporateName.toLowerCase() : ''
      const fantasyName = item.fantasyName ? item.fantasyName.toLowerCase() : ''
      const city = item.city ? item.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
  },
  mounted() {
    this.getData()
  },
  watch:{
    selected_client_id(){
      this.emitClient()
    },
    activeModalityId(){
      this.getData()
    }
  }
}
</script>